const SOURCE_STATUS_TERMINAL = new Set(['ready', 'failed', 'error', 'duplicate']);

export function parseSourceList(response) {
  if (Array.isArray(response?.sources)) {
    return response.sources;
  }
  if (Array.isArray(response?.data?.sources)) {
    return response.data.sources;
  }
  return [];
}

function normalizeSourceStatus(status) {
  return String(status || '').trim().toLowerCase();
}

export function hasPendingSourceProcessing(items = []) {
  if (!Array.isArray(items) || items.length === 0) {
    return false;
  }
  return items.some((item) => !SOURCE_STATUS_TERMINAL.has(normalizeSourceStatus(item?.status)));
}
